export class RoutingInfo {

    private navigationURL?:String[]=[];
    private queryParams?:any={};

    public setNavigationURL(navigationURL:String) {
        this.navigationURL?.push(navigationURL);
    }

    public setQueryParams(queryParams:any) {
        this.queryParams=queryParams;
    }

    public getNavigationURL():String[] | null | undefined   {
        return this.navigationURL;
    }

    public getQueryParams():any {
        return this.queryParams;
    }

  }